import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { X } from 'lucide-react';
import { cn } from '../../lib/utils';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  description?: string;
  children: React.ReactNode;
  maxWidth?: 'sm' | 'md' | 'lg' | 'xl' | '2xl';
}
export function Modal({
  isOpen,
  onClose,
  title,
  description,
  children,
  maxWidth = 'md'
}: ModalProps) {
  const maxWidths = {
    sm: 'max-w-sm',
    md: 'max-w-md',
    lg: 'max-w-lg',
    xl: 'max-w-xl',
    '2xl': 'max-w-2xl'
  };
  return <AnimatePresence data-id="element-96">
      {isOpen && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 z-50 bg-slate-900/50 backdrop-blur-sm" data-id="element-97" />
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4 pointer-events-none" data-id="element-98">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.2
        }} className={cn('w-full bg-white rounded-xl shadow-xl overflow-hidden pointer-events-auto flex flex-col max-h-[90vh]', maxWidths[maxWidth])} data-id="element-99">
              {(title || description) && <div className="px-6 py-4 border-b border-slate-200 bg-brand-50/50 flex items-start justify-between" data-id="element-100">
                  <div data-id="element-101">
                    {title && <h2 className="text-lg font-semibold text-black" data-id="element-102">
                        {title}
                      </h2>}
                    {description && <p className="text-sm text-slate-500 mt-1" data-id="element-103">
                        {description}
                      </p>}
                  </div>
                  <button onClick={onClose} className="text-slate-400 hover:text-accent-500 transition-colors p-1 rounded-md hover:bg-slate-50" data-id="element-104">
                    <X className="h-5 w-5" data-id="element-105" />
                  </button>
                </div>}
              <div className="p-6 overflow-y-auto" data-id="element-106">{children}</div>
            </motion.div>
          </div>
        </>}
    </AnimatePresence>;
}